module.exports = __webpack_public_path__ + "img/cloud3.d372f10f.png";